import React from 'react'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import Tabs from '../components/Tabs'
import Tab from '../components/Tab'
import { Outlet, useLocation } from 'react-router'
import { UserStore } from '../store/userStore'

function ProfileEditPage(): React.ReactElement {
  const [portal, setPortal] = React.useState<HTMLElement | null>(null)
  const BREADCRUMBS = [
    {
      label: 'Главная',
      path: '/'
    },
    {
      label: 'Настройки профиля',
      path: '/profile/edit'
    }
  ]
  const TABS = [
    {
      label: 'Основное',
      path: '/profile/edit'
    },
    {
      label: 'Об организации',
      path: '/profile/edit/about-organization'
    },
    {
      label: 'Образование',
      path: '/profile/edit/education'
    },
    {
      label: 'Опыт работы',
      path: '/profile/edit/job'
    },
    {
      label: 'Знание языков',
      path: '/profile/edit/language'
    },
    {
      label: 'Интересы',
      path: '/profile/edit/features'
    },
    {
      label: 'Смена пароля',
      path: '/profile/edit/password-change'
    }
  ]
  const location = useLocation()

  const filteredTabs = React.useMemo(() => {
    if (!UserStore.data.hasOrganization) {
      return TABS.filter((tab) => tab.path !== '/profile/edit/about-organization');
    }
    return TABS;
  }, [UserStore.data.hasOrganization]);

  React.useEffect(() => {
    const portalTarget = document.getElementById('header-portal')

    if (portalTarget) {
      setPortal(portalTarget)
    }
  }, [])

  return (
    <div className={'page'}>
      <Breadcrumbs
        className={'page__breadcrumbs'}
        breadcrumbs={BREADCRUMBS}
      ></Breadcrumbs>
      {portal &&
        createPortal(<Breadcrumbs breadcrumbs={BREADCRUMBS} />, portal)}

      <header className="page__head">
        <h1>Настройки профиля</h1>
      </header>

      <div className="page__content">
        <Tabs
          initialIndex={filteredTabs.findIndex(
            ({ path }) => location.pathname === path
          )}
          items={filteredTabs}
          renderItem={(item) => {
            return (
              <Tab active={location.pathname === item.path} to={item.path}>
                {item.label}
              </Tab>
            )
          }}
        ></Tabs>

        <div className={'mt-md-8 mt-sm-6'}>
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  )
}

export default ProfileEditPage
